import axios from 'axios'
import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

export function setupI18n(options = { locale: 'en' }) {
	const i18n = createI18n(options)
	setI18nLanguage(i18n, options.locale)
	return i18n
}

export function setI18nLanguage(i18n, locale) {
	i18n.global.locale = locale
}

export async function loadLocaleMessages(i18n, locale) {
	const messages = await axios.get("https://poeditor.brainz.cz/488785/en.json")
	i18n.global.setLocaleMessage(locale, messages.data)
	return nextTick()
}
